import type { FileTypeDTO } from '@uturn/api/v1';
import type { FileTypeOption } from '@uturn/portal/types/shipment';
import { allowedFileTypes } from '@uturn/portal/types/shipment';
import type { TFunction } from 'i18next';

export const getFileTypeOptions = (
	fileTypes: FileTypeDTO[],
	t: TFunction<'translation', undefined>,
): FileTypeOption[] => {
	return fileTypes
		.filter(
			(fileType) =>
				!!fileType.name &&
				!!fileType.code &&
				allowedFileTypes.includes(fileType.code),
		)
		.map((fileType) => {
			const { code, name } = {
				code: fileType.code as string, // Guarantied by Type Predicate Inference
				name: fileType.name as string, // Guarantied by Type Predicate Inference
			};

			const option: FileTypeOption = {
				label: t(`general.file-types.${code}`, name),
				value: code,
				order: allowedFileTypes.indexOf(code),
			};

			return option;
		})
		.sort((a, b) => a.order - b.order);
};
